// import img1 from "../../Image/scooter2.png";
import scooty_1_1 from "../../Image/scootys image/scooty1/novabike.png";
import scooty_1_2 from "../../Image/scootys image/scooty1/left-side-scooty.png";
import scooty_1_3 from "../../Image/scootys image/scooty1/right-side-scooty-2.png";
import scooty_1_4 from "../../Image/scootys image/scooty1/nova-green4.png";
import scooty_1_5 from "../../Image/scootys image/scooty1/nova-green5-2.png";
import scooty_1_6 from "../../Image/scootys image/scooty1/middle-scooty_.png";

import scooty_2_1 from "../../Image/scootys image/nava-s/individual_standees_NOVA_S__1__page-0001__1_-removebg-preview.png";
import scooty_2_2 from "../../Image/scootys image/nava-s/Front-Nova-S-1.png";
import scooty_2_3 from "../../Image/scootys image/nava-s/Left-Side-Nova-S-1.png";
import scooty_2_4 from "../../Image/scootys image/nava-s/Left-Side-Nova-S-2.png";
import scooty_2_5 from "../../Image/scootys image/nava-s/Left-Side-Nova-S2.png";
import scooty_2_6 from "../../Image/scootys image/nava-s/Left-1-1.png";

import scooty_3_1 from "../../Image/scootys image/novo-x/novax-orange7.png";
import scooty_3_2 from "../../Image/scootys image/novo-x/DSC02859.png";
import scooty_3_3 from "../../Image/scootys image/novo-x/DSC02859-1.png";
import scooty_3_4 from "../../Image/scootys image/novo-x/novax-orange2.png";
import scooty_3_5 from "../../Image/scootys image/novo-x/novax-orange3.png";
import scooty_3_6 from "../../Image/scootys image/novo-x/right-side-scooty-2.png";

import scooty_4_1 from "../../Image/scootys image/Edga/edgeblack3.png";
import scooty_4_2 from "../../Image/scootys image/Edga/edgeblack6.png";
import scooty_4_3 from "../../Image/scootys image/Edga/edgeblack1.png";
import scooty_4_4 from "../../Image/scootys image/Edga/edgeblack2.png";
import scooty_4_5 from "../../Image/scootys image/Edga/edgeblack4.png";
import scooty_4_6 from "../../Image/scootys image/Edga/edgeblack5.png";

import scooty_5_1 from "../../Image/scootys image/Edge_plus/novaplus5.png";
import scooty_5_2 from "../../Image/scootys image/Edge_plus/novaplus4.png";
import scooty_5_3 from "../../Image/scootys image/Edge_plus/edgeplussection2.png";
import scooty_5_4 from "../../Image/scootys image/Edge_plus/Group-1-1.png";
import scooty_5_5 from "../../Image/scootys image/Edge_plus/eggeplus.png";
import scooty_5_6 from "../../Image/scootys image/Edge_plus/edgeplussection2.png";

import scooty_6_1 from "../../Image/scootys image/neo/neoteal2.png";
import scooty_6_2 from "../../Image/scootys image/neo/Group-14.png";
import scooty_6_3 from "../../Image/scootys image/neo/neoteal6.png";
import scooty_6_4 from "../../Image/scootys image/neo/neoteal3.png";
import scooty_6_5 from "../../Image/scootys image/neo/neoteal5.png";
import scooty_6_6 from "../../Image/scootys image/neo/neoteal7.png";

import scooty_7_1 from "../../Image/scootys image/Edga 5G/Screenshot 2026-01-12 193537-Photoroom.png";
import scooty_7_2 from "../../Image/scootys image/Edga 5G/Screenshot 2026-01-12 191853-Photoroom.png";
import scooty_7_3 from "../../Image/scootys image/Edga 5G/Screenshot 2026-01-12 191911-Photoroom.png";
import scooty_7_4 from "../../Image/scootys image/Edga 5G/Screenshot 2026-01-12 191920-Photoroom.png";
import scooty_7_5 from "../../Image/scootys image/Edga 5G/Screenshot 2026-01-12 191939-Photoroom.png";
import scooty_7_6 from "../../Image/scootys image/Edga 5G/Screenshot 2026-01-12 191911-Photoroom.png";

// import scooty_8_1 from "../../Image/scootys image/scooty5/novaplus5.png";
// import scooty_8_2 from "../../Image/scootys image/scooty5/novaplus4.png";
// import scooty_8_3 from "../../Image/scootys image/scooty5/novaplus2.png";
// import scooty_8_4 from "../../Image/scootys image/scooty5/Group-1-1.png";
// import scooty_8_5 from "../../Image/scootys image/scooty5/eggeplus.png";
// import scooty_8_6 from "../../Image/scootys image/scooty5/edgeplussection2.png";

import scooty_9_1 from "../../Image/scootys image/Shark/Screenshot Photoroom.png";
import scooty_9_2 from "../../Image/scootys image/Shark/Screenshot 2026-01-12 202323-Photoroom.png";
import scooty_9_3 from "../../Image/scootys image/Shark/Screenshot 2026-01-12 202335-Photoroom.png";
import scooty_9_4 from "../../Image/scootys image/Shark/Screenshot 2026-01-12 202345-Photoroom.png";
import scooty_9_5 from "../../Image/scootys image/Shark/Screenshot 2026-01-12 202400-Photoroom.png";
import scooty_9_6 from "../../Image/scootys image/Shark/Screenshot 2026-01-12 202413-Photoroom.png";

import scooty_10_1 from "../../Image/scootys image/ALEXA/Screenshot 2026-01-12 203534-Photoroom.png";
import scooty_10_2 from "../../Image/scootys image/ALEXA/Screenshot 2026-01-12 203425-Photoroom.png";
import scooty_10_3 from "../../Image/scootys image/ALEXA/Screenshot 2026-01-12 204145-Photoroom.png";
import scooty_10_4 from "../../Image/scootys image/ALEXA/Screenshot 2026-01-12 203434-Photoroom.png";
import scooty_10_5 from "../../Image/scootys image/ALEXA/Screenshot 2026-01-12 203447-Photoroom.png";
import scooty_10_6 from "../../Image/scootys image/ALEXA/Screenshot 2026-01-12 203457-Photoroom.png";

import scooty_11_1 from "../../Image/scootys image//Cruze/Screenshot 2026-01-12 194425-Photoroom.png";
import scooty_11_2 from "../../Image/scootys image/Cruze/Screenshot 2026-01-12 194259-Photoroom.png";
import scooty_11_3 from "../../Image/scootys image/Cruze/Screenshot 2026-01-12 194313-Photoroom.png";
import scooty_11_4 from "../../Image/scootys image/Cruze/Screenshot 2026-01-12 194326-Photoroom.png";
import scooty_11_5 from "../../Image/scootys image/Cruze/Screenshot 2026-01-12 194341-Photoroom.png";
import scooty_11_6 from "../../Image/scootys image/Cruze/Screenshot 2026-01-12 194412-Photoroom.png";

// import scooty_12_1 from "../../Image/scootys image/scooty5/novaplus5.png";
// import scooty_12_2 from "../../Image/scootys image/scooty5/novaplus4.png";
// import scooty_12_3 from "../../Image/scootys image/scooty5/novaplus2.png";
// import scooty_12_4 from "../../Image/scootys image/scooty5/Group-1-1.png";
// import scooty_12_5 from "../../Image/scootys image/scooty5/eggeplus.png";
// import scooty_12_6 from "../../Image/scootys image/scooty5/edgeplussection2.png";
//
// import scooty_13_1 from "../../Image/scootys image/scooty5/novaplus5.png";
// import scooty_13_2 from "../../Image/scootys image/scooty5/novaplus4.png";
// import scooty_13_3 from "../../Image/scootys image/scooty5/novaplus2.png";
// import scooty_13_4 from "../../Image/scootys image/scooty5/Group-1-1.png";
// import scooty_13_5 from "../../Image/scootys image/scooty5/eggeplus.png";
// import scooty_13_6 from "../../Image/scootys image/scooty5/edgeplussection2.png";

const productData = [
  {
    id: 1,
    name: "NOVA",
    price: "₹75,500",
    image: scooty_1_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["#000000", "#657e80", "#424141", "#3b5a41"],
    allImages: [
      scooty_1_1,
      scooty_1_2,
      scooty_1_3,
      scooty_1_4,
      scooty_1_5,
      scooty_1_6,
    ],
    rating: 5,
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1900 X 680 X 1160 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/90/12",
        Rear: "90/100/10",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb Weight w/o battery": {
        KG: "62.00 kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
    /* ✅ ADDED */
  },
  {
    id: 2,
    name: "NOVA-S",
    price: "₹84,500",
    image: scooty_2_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["#c62828", "#1565c0", "#4dd0e1"],
    allImages: [
      scooty_2_1,
      scooty_2_2,
      scooty_2_3,
      scooty_2_4,
      scooty_2_5,
      scooty_2_6,
    ],
    rating: 4,

    /* ✅ ADDED */
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1875 X 680 X 1200 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/90/12",
        Rear: "90/90/12",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb weight w/o battery": {
        KG: "78.000 Kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      Battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
  },
  {
    id: 3,
    name: "NOVA-x",
    price: "₹78,500",
    image: scooty_3_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["#ffffff", "#ffb300", "#90caf9", "#c5e1a5"],
    allImages: [
      scooty_3_1,
      scooty_3_2,
      scooty_3_3,
      scooty_3_4,
      scooty_3_5,
      scooty_3_6,
    ],
    rating: 4,
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1950 X 660 X 1300 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/90/12",
        Rear: "90/90/12",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb weight w/o battery": {
        KG: "75.500 Kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      Battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
    /* ✅ ADDED */
  },

  {
    id: 4,
    name: "EDGE",
    price: "₹60,000",
    image: scooty_4_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["#c62828", "#1565c0", "#4dd0e1"],
    allImages: [
      scooty_4_1,
      scooty_4_2,
      scooty_4_3,
      scooty_4_4,
      scooty_4_5,
      scooty_4_6,
    ],
    rating: 4,

    /* ✅ ADDED */
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1870 X 720 X 1150 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/90/12",
        Rear: "90/100/10",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb weight w/o battery": {
        KG: "64.000 Kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      Battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
  },
  {
    id: 5,
    name: "EDGE PLUS",
    price: "₹65,000",
    image: scooty_5_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["silver", "#006D5b", "#191970"],
    allImages: [
      scooty_5_1,
      scooty_5_2,
      scooty_5_3,
      scooty_5_4,
      scooty_5_5,
      scooty_5_6,
    ],
    rating: 4,

    /* ✅ ADDED */
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1900 X 680 X 1160 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/90/12",
        Rear: "90/100/10",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb weight w/o battery": {
        KG: "62.00 Kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      Battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
  },
  {
    id: 6,
    name: "WARIVO NEO",
    price: "₹57,000",
    image: scooty_6_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["#c62828", "#1565c0", "#4dd0e1"],
    allImages: [
      scooty_6_1,
      scooty_6_2,
      scooty_6_3,
      scooty_6_4,
      scooty_6_5,
      scooty_6_6,
    ],
    rating: 4,

    /* ✅ ADDED */
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1800 X 660 X 1100 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/100/10",
        Rear: "90/100/10",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb weight w/o battery": {
        KG: "58.500 Kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      Battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
  },
  {
    id: 7,
    name: "ELITE 5G",
    price: "₹52,500",
    image: scooty_7_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["#c62828", "#1565c0", "#4dd0e1"],
    allImages: [
      scooty_7_1,
      scooty_7_2,
      scooty_7_3,
      scooty_7_4,
      scooty_7_5,
      scooty_7_6,
    ],
    rating: 4,

    /* ✅ ADDED */
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1800 X 660 X 1100 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/100/10",
        Rear: "90/100/10",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb weight w/o battery": {
        KG: "58.500 Kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      Battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
  },

  //   {
  //     id: 8,
  //     name: "ELITE 5G-2.0",
  //     price: "₹54,500",
  //     image: img1,
  //     range: "Upto 130 KM",
  //     speed: "LOW SPEED",
  //     colors: ["#c62828", "#1565c0", "#4dd0e1"],
  //     allImages: [
  //       scooty_8_1,
  //       scooty_8_2,
  //       scooty_8_3,
  //       scooty_8_4,
  //       scooty_8_5,
  //       scooty_8_6,
  //     ],
  //     rating: 4,
  //    full_detail: {
  //       Dimension: {
  //         "Dimensions(LxWxH)mm": "1875 X 680 X 1200 mm",
  //       },
  //
  //       Brake: {
  //         Type: "Front Disc / Rear Drum",
  //       },
  //
  //       Tyre: {
  //         Type: "Tubeless",
  //         Front: "90/90/12",
  //         Rear: "90/90/12",
  //       },
  //
  //       Suspension: {
  //         Front: "Telescopic",
  //         Rear: "Dual",
  //       },
  //
  //       "Kerb weight w/o battery": {
  //         KG: "78.000 Kg",
  //       },
  //
  //       "Front Wheel Rim": {
  //         Type: "Alloy",
  //       },
  //
  //       Battery: ["Lead Acid", "Lithium"],
  //
  //       Range: ["Upto 130 KMs"],
  //     },
  //
  //     /* ✅ ADDED */
  // Warranty: {
  //   Battery: "3 Years Warranty on Lithium Battery",
  //   Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
  // },
  //   },

  {
    id: 9,
    name: "SHARK",
    price: "₹54,500",
    image: scooty_9_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["#c62828", "#1565c0", "#4dd0e1"],
    allImages: [
      scooty_9_1,
      scooty_9_2,
      scooty_9_3,
      scooty_9_4,
      scooty_9_5,
      scooty_9_6,
    ],
    rating: 4,

    /* ✅ ADDED */
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1800 X 660 X 1100 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/100/10",
        Rear: "90/100/10",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb weight w/o battery": {
        KG: "58.500 Kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      Battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
  },
  {
    id: 10,
    name: "ALEXA",
    price: "₹62,000",
    image: scooty_10_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["#c62828", "#1565c0", "#4dd0e1"],
    allImages: [
      scooty_10_1,
      scooty_10_2,
      scooty_10_3,
      scooty_10_4,
      scooty_10_5,
      scooty_10_6,
    ],
    rating: 4,

    /* ✅ ADDED */
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1875 X 680 X 1200 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/90/12",
        Rear: "90/90/12",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb weight w/o battery": {
        KG: "78.000 Kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      Battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
  },
  {
    id: 11,
    name: "CRUZE",
    price: "₹67,649",
    image: scooty_11_1,
    range: "Upto 130 KM",
    speed: "LOW SPEED",
    colors: ["#c62828", "#1565c0", "#4dd0e1"],
    allImages: [
      scooty_11_1,
      scooty_11_2,
      scooty_11_3,
      scooty_11_4,
      scooty_11_5,
      scooty_11_6,
    ],
    rating: 4,

    /* ✅ ADDED */
    full_detail: {
      Dimension: {
        "Dimensions(LxWxH)mm": "1875 X 680 X 1200 mm",
      },

      Brake: {
        Type: "Front Disc / Rear Drum",
      },

      Tyre: {
        Type: "Tubeless",
        Front: "90/90/12",
        Rear: "90/90/12",
      },

      Suspension: {
        Front: "Telescopic",
        Rear: "Dual",
      },

      "Kerb weight w/o battery": {
        KG: "78.000 Kg",
      },

      "Front Wheel Rim": {
        Type: "Alloy",
      },

      Battery: ["Lead Acid", "Lithium"],

      range: ["Upto 130 KMs"],

      Headlight: "Projector Lamp",
    },
    Warranty: {
      Battery: "3 Years Warranty on Lithium Battery",
      Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
    },
  },

  //   {
  //     id: 12,
  //     name: "L1-PLUS",
  //     price: "₹59,500",
  //     image: img1,
  //     range: "Upto 130 KM",
  //     speed: "LOW SPEED",
  //     colors: ["#c62828", "#1565c0", "#4dd0e1"],
  //     allImages: [
  //       scooty_12_1,
  //       scooty_12_2,
  //       scooty_12_3,
  //       scooty_12_4,
  //       scooty_12_5,
  //       scooty_12_6,
  //     ],
  //     rating: 4,
  //     full_detail: {
  //       Dimension: {
  //         "Dimensions(LxWxH)mm": "1875 X 680 X 1200 mm",
  //       },
  //
  //       Brake: {
  //         Type: "Front Disc / Rear Drum",
  //       },
  //
  //       Tyre: {
  //         Type: "Tubeless",
  //         Front: "90/90/12",
  //         Rear: "90/90/12",
  //       },
  //
  //       Suspension: {
  //         Front: "Telescopic",
  //         Rear: "Dual",
  //       },
  //
  //       "Kerb weight w/o battery": {
  //         KG: "78.000 Kg",
  //       },
  //
  //       "Front Wheel Rim": {
  //         Type: "Alloy",
  //       },
  //
  //       Battery: ["Lead Acid", "Lithium"],
  //
  //       range: ["Upto 130 KMs"],
  //
  //       Headlight: "Projector Lamp",
  //     },
  //     Warranty: {
  //       Battery: "3 Years Warranty on Lithium Battery",
  //       Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
  //     },
  //     /* ✅ ADDED */
  //   },
  //   {
  //     id: 13,
  //     name: "REVO BOAT",
  //     price: "₹64,500",
  //     image: img1,
  //     range: "Upto 130 KM",
  //     speed: "LOW SPEED",
  //     colors: ["#c62828", "#1565c0", "#4dd0e1"],
  //     allImages: [
  //       scooty_13_1,
  //       scooty_13_2,
  //       scooty_13_3,
  //       scooty_13_4,
  //       scooty_13_5,
  //       scooty_13_6,
  //     ],
  //     rating: 4,
  //     full_detail: {
  //       Dimension: {
  //         "Dimensions(LxWxH)mm": "1875 X 680 X 1200 mm",
  //       },
  //
  //       Brake: {
  //         Type: "Front Disc / Rear Drum",
  //       },
  //
  //       Tyre: {
  //         Type: "Tubeless",
  //         Front: "90/90/12",
  //         Rear: "90/90/12",
  //       },
  //
  //       Suspension: {
  //         Front: "Telescopic",
  //         Rear: "Dual",
  //       },
  //
  //       "Kerb weight w/o battery": {
  //         KG: "78.000 Kg",
  //       },
  //
  //       "Front Wheel Rim": {
  //         Type: "Alloy",
  //       },
  //
  //       Battery: ["Lead Acid", "Lithium"],
  //
  //       range: ["Upto 130 KMs"],
  //
  //       Headlight: "Projector Lamp",
  //     },
  //
  //     /* ✅ ADDED */
  //     Warranty: {
  //       Battery: "3 Years Warranty on Lithium Battery",
  //       Vehicle: "1 Year Warranty on Chassis, Motor, Controller, Charger",
  //     },
  //   },
];

export default productData;
